import "./styles.css";
import { Checkbox, CheckboxProps, FormControlLabel } from "@mui/material";

function CheckboxInput({
  label,
  className,
  sx,
  ...rest
}: CheckboxProps & { label?: string }) {
  return (
    <FormControlLabel
      sx={{ m: 0 }}
      label={label ?? ""}
      control={
        <Checkbox
          size="small"
          sx={{
            p: "var(--gap-xs)",
            color: "var(--color-dark)",
            "&.Mui-checked": {
              color: "var(--color-fasmr-blue)",
            },
            ...sx,
          }}
          className={"checkbox-input " + (className ?? "")}
          {...rest}
        />
      }
    />
  );
}

export default CheckboxInput;
